export default {"src":"/_next/static/media/paypal-grey.1b212682.svg","height":12,"width":40,"blurWidth":0,"blurHeight":0};